import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { startOfWeek, endOfWeek, weeksToDays } from 'date-fns'

@Injectable({
  providedIn: 'root'
})
export class helperFunctions{
  constructor(private datePipe:DatePipe){}

  public dateToString(format:string, date?:Date | null):string{
    let sDate = this.datePipe.transform(date, format);
    if (sDate){
      return sDate
    } else {
      return '';
    }
  }

  public getDatesFromWeekNumber(weekNumberList:any[], startYear: number, endYear:number): {startDate: Date, endDate:Date}{
    let requestedStartDate = new Date(startYear, 0, 1);
    requestedStartDate.setDate(requestedStartDate.getDate() + weeksToDays(weekNumberList[0])-1);
    requestedStartDate = startOfWeek(requestedStartDate, {weekStartsOn: 1});

    let requestedEndDate = new Date(endYear, 0, 1);
    requestedEndDate.setDate(requestedEndDate.getDate() + weeksToDays(weekNumberList[weekNumberList.length -1])-1);
    requestedEndDate = endOfWeek(requestedEndDate, {weekStartsOn: 1});
    return {startDate: requestedStartDate, endDate: requestedEndDate};
  }
}
